import Area from '@/model/area'
import Hit from '@/model/hit'
import Match from '@/model/match'
import Player from '@/model/player'
import Score from '@/model/score'
import Target from '@/model/target'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function stringify (value: any): string {
  return JSON.stringify(value)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function instanciate (value: any): any {
  if (Array.isArray(value)) {
    return value.map(item => instanciate(item))
  }

  if ((value != null) && (typeof value === 'object')) {
    for (const [property, propertyValue] of Object.entries(value)) {
      value[property] = instanciate(propertyValue)
    }

    if (value._class != null) {
      let instance
      switch (value._class) {
        case 'Area':
          instance = new Area()
          break
        case 'Hit':
          instance = new Hit()
          break
        case 'Match':
          instance = new Match()
          break
        case 'Player':
          instance = new Player()
          break
        case 'Score':
          instance = new Score()
          break
        case 'Target':
          instance = new Target()
          break
      }
      if (instance != null) {
        value = Object.assign(instance, value)
      }
    }
  }

  return value
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parse (text: string): any {
  const value = JSON.parse(text)

  return instanciate(value)
}
